(function () {
  if (window.__asteromColorMediaByVariantLoaded) return;
  window.__asteromColorMediaByVariantLoaded = true;

  function norm(value) {
    return String(value || '').trim().toLowerCase();
  }

  function handle(value) {
    return norm(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function colorGroup(productInfo) {
    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return null;

    var groups = variantSelects.querySelectorAll('.product-form__input, .product-custom__option');
    for (var index = 0; index < groups.length; index += 1) {
      var group = groups[index];
      var legend = group.querySelector('legend');
      var label = group.querySelector('.product-custom__option-label');
      var text = norm(
        (legend ? legend.textContent : '') +
          ' ' +
          (label ? label.textContent : '') +
          ' ' +
          (group.getAttribute('aria-label') || '') +
          ' ' +
          (group.getAttribute('class') || '')
      );

      if (text.indexOf('color') > -1 || text.indexOf('colour') > -1) return group;
    }

    return null;
  }

  function selectedColor(group) {
    var radio = group.querySelector('input[type=radio]:checked');
    if (radio && radio.value) return radio.value;

    var select = group.querySelector('select');
    if (select && select.value) return select.value;

    var selected =
      group.querySelector('[data-selected-value]') ||
      group.querySelector('.product-custom__selected-value');

    return selected ? selected.textContent.trim() : '';
  }

  function colorValues(group) {
    var values = [];
    var fields = group.querySelectorAll('input[type=radio], option');

    for (var index = 0; index < fields.length; index += 1) {
      values.push(handle(fields[index].value || fields[index].textContent));
    }

    values.push(handle(selectedColor(group)));
    return Array.from(new Set(values.filter(Boolean)));
  }

  function slideAlt(slide) {
    var image = slide.querySelector('img');
    return slide.getAttribute('data-media-alt') || (image && image.getAttribute('alt')) || '';
  }

  function mediaId(slide) {
    return String(slide.getAttribute('data-media-id') || '');
  }

  function thumbMediaId(thumb) {
    return String(thumb.getAttribute('data-target') || '');
  }

  function containsColor(altHandle, colorHandle) {
    if (!altHandle || !colorHandle) return false;

    return (
      altHandle === colorHandle ||
      altHandle.indexOf('-' + colorHandle + '-') > -1 ||
      altHandle.indexOf(colorHandle + '-') === 0 ||
      altHandle.lastIndexOf('-' + colorHandle) === altHandle.length - colorHandle.length - 1 ||
      altHandle === 'color-' + colorHandle ||
      altHandle.indexOf('color-' + colorHandle + '-') === 0
    );
  }

  function colorMatchCount(altHandle, values) {
    var count = 0;

    for (var index = 0; index < values.length; index += 1) {
      if (containsColor(altHandle, values[index])) count += 1;
    }

    return count;
  }

  function revealImages(container) {
    if (!container) return;

    container.querySelectorAll('img').forEach(function (image) {
      var src = image.dataset.defersrc || image.dataset.src;
      var srcset = image.dataset.defersrcset || image.dataset.srcset;
      var sizes = image.dataset.defersizes;

      if (srcset) image.setAttribute('srcset', srcset);
      if (sizes) image.setAttribute('sizes', sizes);
      if (src) image.setAttribute('src', src);

      image.removeAttribute('data-defersrcset');
      image.removeAttribute('data-defersizes');
      image.removeAttribute('data-defersrc');
      image.removeAttribute('data-srcset');
      image.removeAttribute('data-src');
      image.setAttribute('loading', 'eager');
    });
  }

  function lightboxDataSource(slides) {
    return slides.map(function (slide, index) {
      var mediaType = slide.dataset.mediaType;
      var source = {
        id: String(index),
        mediaType: mediaType
      };

      if (
        mediaType === 'model' ||
        mediaType === 'video' ||
        mediaType === 'external_video'
      ) {
        var htmlTag = mediaType === 'model' ? 'product-model' : 'video-element';
        var mediaElement = slide.querySelector(htmlTag);

        if (mediaElement) {
          source.html =
            '<div class="pswp__item--' +
            mediaType +
            '">' +
            mediaElement.outerHTML +
            '</div>';
        }
      } else {
        source.src = slide.dataset.src;
        source.width = slide.dataset.pswpWidth;
        source.height = slide.dataset.pswpHeight;
      }

      return source;
    });
  }

  function syncLightbox(gallery, state, slides) {
    slides.forEach(function (slide, index) {
      slide.dataset.mediaIndex = String(index);

      var zoomButton = slide.querySelector('.js-photoswipe--zoom');
      if (zoomButton) zoomButton.dataset.mediaIndex = String(index);
    });

    state.lightboxDataSource = lightboxDataSource(slides);

    var lightbox = gallery.lightbox;
    if (!lightbox) return;

    if (lightbox.options) {
      lightbox.options.dataSource = state.lightboxDataSource;
    }

    if (lightbox.__asteromColorMediaPatched) return;

    var originalLoadAndOpen = lightbox.loadAndOpen;
    lightbox.loadAndOpen = function (index, dataSource, initialPoint) {
      var latestState = gallery.__asteromColorMediaState;
      var currentSource =
        latestState && latestState.lightboxDataSource
          ? latestState.lightboxDataSource
          : dataSource;
      var nextIndex = Number(index);
      var slider =
        gallery.sliderInstance && gallery.sliderInstance.slider
          ? gallery.sliderInstance.slider
          : null;

      if (
        !currentSource ||
        !currentSource.length ||
        !Number.isFinite(nextIndex) ||
        nextIndex < 0 ||
        nextIndex >= currentSource.length
      ) {
        nextIndex = slider ? slider.activeIndex : 0;
      }

      return originalLoadAndOpen.call(this, nextIndex, currentSource, initialPoint);
    };

    lightbox.__asteromColorMediaPatched = true;
  }

  function resetSlide(slide) {
    slide.classList.remove(
      'swiper-slide-active',
      'swiper-slide-prev',
      'swiper-slide-next',
      'swiper-slide-visible',
      'swiper-slide-fully-visible',
      'swiper-slide-thumb-active'
    );
    slide.style.removeProperty('width');
    slide.style.removeProperty('height');
    slide.style.removeProperty('margin-right');
    slide.style.removeProperty('margin-bottom');
    slide.style.removeProperty('transform');
    slide.removeAttribute('data-swiper-slide-index');
    slide.removeAttribute('aria-label');
    slide.removeAttribute('role');
  }

  function resetSwiperElement(element) {
    if (!element) return;

    element.classList.remove(
      'swiper-initialized',
      'swiper-horizontal',
      'swiper-vertical',
      'swiper-backface-hidden',
      'swiper-thumbs',
      'swiper-watch-progress',
      'swiper-free-mode'
    );
  }

  function destroySwiper(instance) {
    var slider = instance && instance.slider;
    if (!slider || slider.destroyed || typeof slider.destroy !== 'function') return;
    slider.destroy(true, true);
  }

  function stopGallery(gallery) {
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia(gallery);

    destroySwiper(gallery.sliderInstance);
    destroySwiper(gallery.thumbsInstance);

    gallery.sliderInstance = false;
    gallery.thumbsInstance = false;

    if (gallery.sliderOptions && gallery.sliderOptions.thumbs) {
      delete gallery.sliderOptions.thumbs;
    }
  }

  function replaceSlides(wrapper, allSlides, visibleSlides) {
    allSlides.forEach(function (slide) {
      if (slide.parentNode === wrapper) wrapper.removeChild(slide);
      resetSlide(slide);
    });

    var fragment = document.createDocumentFragment();
    visibleSlides.forEach(function (slide) {
      fragment.appendChild(slide);
    });
    wrapper.appendChild(fragment);
  }

  function sameSlides(wrapper, slides) {
    if (!wrapper || wrapper.children.length !== slides.length) return false;

    for (var index = 0; index < slides.length; index += 1) {
      if (wrapper.children[index] !== slides[index]) return false;
    }

    return true;
  }

  function activateFirst(gallery, state) {
    var mainSlider =
      gallery.sliderInstance && gallery.sliderInstance.slider
        ? gallery.sliderInstance.slider
        : null;
    var thumbsSlider =
      gallery.thumbsInstance && gallery.thumbsInstance.slider
        ? gallery.thumbsInstance.slider
        : null;

    if (thumbsSlider) {
      thumbsSlider.update();
      thumbsSlider.slideTo(0, 0, false);
      if (thumbsSlider.updateSlidesClasses) thumbsSlider.updateSlidesClasses();
    }

    if (mainSlider) {
      mainSlider.update();
      mainSlider.slideTo(0, 0, false);
      if (mainSlider.updateAutoHeight) mainSlider.updateAutoHeight(0);
      if (mainSlider.updateSlidesClasses) mainSlider.updateSlidesClasses();
    }

    if (!mainSlider && state.mainWrapper.firstElementChild) {
      state.mainWrapper.firstElementChild.classList.add('swiper-slide-active');
    }

    if (!thumbsSlider && state.thumbsWrapper && state.thumbsWrapper.firstElementChild) {
      state.thumbsWrapper.firstElementChild.classList.add('swiper-slide-thumb-active');
    }
  }

  function restartGallery(gallery, state) {
    resetSwiperElement(state.viewer);
    resetSwiperElement(state.thumbnails);

    if (
      gallery.initialized === true &&
      typeof gallery.initSlider === 'function' &&
      (gallery.enableDesktopSlider || (window.FoxTheme && FoxTheme.config.mqlMobile))
    ) {
      gallery.initSlider();
    }

    activateFirst(gallery, state);

    window.requestAnimationFrame(function () {
      activateFirst(gallery, state);
    });
  }

  function galleryState(productInfo) {
    var gallery = productInfo.querySelector('media-gallery');
    if (!gallery) return null;

    var mainWrapper = gallery.querySelector('[id^=Slider-Gallery-]');
    if (!mainWrapper) return null;

    var thumbsWrapper = gallery.querySelector('[id^=Slider-Thumbnails-]');
    var existing = gallery.__asteromColorMediaState;

    if (
      existing &&
      existing.mainWrapper === mainWrapper &&
      existing.thumbsWrapper === thumbsWrapper
    ) {
      return existing;
    }

    var state = {
      key: '',
      gallery: gallery,
      viewer: gallery.querySelector('[id^=GalleryViewer-]'),
      thumbnails: gallery.querySelector('[id^=GalleryThumbnails-]'),
      mainWrapper: mainWrapper,
      thumbsWrapper: thumbsWrapper,
      mainSlides: Array.from(mainWrapper.children).filter(function (slide) {
        return slide.classList.contains('product__media-item');
      }),
      thumbSlides: thumbsWrapper
        ? Array.from(thumbsWrapper.children).filter(function (thumb) {
            return thumb.classList.contains('product__thumbs-item');
          })
        : []
    };

    gallery.__asteromColorMediaState = state;
    return state;
  }

  function visibleMainSlides(state, selectedHandle, values) {
    var matched = [];
    var generic = [];
    var hasSpecific = false;

    state.mainSlides.forEach(function (slide) {
      var altHandle = handle(slideAlt(slide));
      var matchCount = colorMatchCount(altHandle, values);

      if (matchCount === 1) {
        hasSpecific = true;
        if (containsColor(altHandle, selectedHandle)) matched.push(slide);
      } else {
        generic.push(slide);
      }
    });

    if (hasSpecific && !matched.length) return state.mainSlides.slice();
    return matched.concat(generic);
  }

  function visibleThumbSlides(state, mainSlides) {
    if (!state.thumbsWrapper) return [];

    var thumbsById = new Map();
    state.thumbSlides.forEach(function (thumb) {
      var id = thumbMediaId(thumb);
      if (!thumbsById.has(id)) thumbsById.set(id, thumb);
    });

    var thumbs = [];
    mainSlides.forEach(function (slide) {
      var thumb = thumbsById.get(mediaId(slide));
      if (thumb) thumbs.push(thumb);
    });

    return thumbs;
  }

  function applyFilter(productInfo) {
    var group = colorGroup(productInfo);
    if (!group) return;

    var selectedHandle = handle(selectedColor(group));
    var values = colorValues(group);
    if (!selectedHandle || !values.length) return;

    var state = galleryState(productInfo);
    if (!state || !state.mainSlides.length) return;

    var mainSlides = visibleMainSlides(state, selectedHandle, values);
    var thumbSlides = visibleThumbSlides(state, mainSlides);
    var key = selectedHandle + '|' + values.join('|');

    if (
      state.key === key &&
      sameSlides(state.mainWrapper, mainSlides) &&
      (!state.thumbsWrapper || sameSlides(state.thumbsWrapper, thumbSlides))
    ) {
      syncLightbox(state.gallery, state, mainSlides);
      return;
    }

    state.key = key;
    stopGallery(state.gallery);
    replaceSlides(state.mainWrapper, state.mainSlides, mainSlides);
    if (state.thumbsWrapper) {
      replaceSlides(state.thumbsWrapper, state.thumbSlides, thumbSlides);
    }

    revealImages(state.mainWrapper);
    revealImages(state.thumbsWrapper);
    syncLightbox(state.gallery, state, mainSlides);
    restartGallery(state.gallery, state);
  }

  function productInfos(root) {
    if (root) {
      var closest = root.closest && root.closest('product-info');
      if (closest) return [closest];

      var inside = root.querySelector && root.querySelector('product-info');
      if (inside) return [inside];
    }

    return Array.from(document.querySelectorAll('product-info'));
  }

  function schedule(root) {
    productInfos(root).forEach(function (productInfo) {
      var version = (productInfo.__asteromColorMediaVersion || 0) + 1;
      productInfo.__asteromColorMediaVersion = version;

      [0, 80, 240].forEach(function (delay) {
        window.setTimeout(function () {
          if (productInfo.__asteromColorMediaVersion === version) {
            applyFilter(productInfo);
          }
        }, delay);
      });
    });
  }

  function featuredMedia(variant) {
    if (!variant) return null;
    if (variant.featured_media) return variant.featured_media;
    if (variant.featured_image) return variant.featured_image;
    return null;
  }

  function patchMediaGallery() {
    var MediaGallery = customElements.get('media-gallery');
    if (!MediaGallery || MediaGallery.prototype.__asteromColorMediaPatched) return;

    var originalSetActiveMedia = MediaGallery.prototype.setActiveMedia;
    var originalInitImageZoom = MediaGallery.prototype.initImageZoom;

    MediaGallery.prototype.initImageZoom = function () {
      var result = originalInitImageZoom.apply(this, arguments);
      var state = this.__asteromColorMediaState;

      if (state) {
        syncLightbox(this, state, Array.from(state.mainWrapper.children));
      }

      return result;
    };

    MediaGallery.prototype.setActiveMedia = function (variant) {
      var state = this.__asteromColorMediaState;
      if (!state || !state.key) {
        return originalSetActiveMedia.apply(this, arguments);
      }

      var featured = featuredMedia(variant);
      var target = featured
        ? state.mainWrapper.querySelector('[data-media-id="' + featured.id + '"]')
        : null;
      var slider =
        this.sliderInstance && this.sliderInstance.slider ? this.sliderInstance.slider : null;

      if (slider) {
        var slides = Array.from(slider.slides || state.mainWrapper.children);
        var index = target ? slides.indexOf(target) : -1;
        slider.slideTo(index > -1 ? index : 0, 0, false);
        return;
      }

      target = target || state.mainWrapper.firstElementChild;
      if (target && target.parentNode === state.mainWrapper) {
        state.mainWrapper.insertBefore(target, state.mainWrapper.firstElementChild);
      }
    };

    MediaGallery.prototype.__asteromColorMediaPatched = true;
  }

  customElements.whenDefined('media-gallery').then(patchMediaGallery);

  function start() {
    patchMediaGallery();
    schedule();

    var tries = 0;
    var interval = window.setInterval(function () {
      tries += 1;
      schedule();
      if (tries >= 30) window.clearInterval(interval);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener(
    'change',
    function (event) {
      if (event.target.closest('variant-selects')) schedule(event.target);
    },
    true
  );

  document.addEventListener('variant:changed', function () {
    schedule();
  });
  document.addEventListener('variant:change', function () {
    schedule();
  });
  document.addEventListener('shopify:section:load', function (event) {
    schedule(event.target);
  });

  var replaceState = history.replaceState;
  history.replaceState = function () {
    replaceState.apply(this, arguments);
    schedule();
  };

  var pushState = history.pushState;
  history.pushState = function () {
    pushState.apply(this, arguments);
    schedule();
  };

  window.addEventListener('popstate', function () {
    schedule();
  });
})();
